import { Component } from '@angular/core';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { AuthService } from '../../services/auth.service';
import { SideBarService } from '../../services/sidebar.service';
import { select, Store } from '@ngrx/store';
import { distinctUntilChanged, map } from 'rxjs';
import { setMenuAct } from '../../store/menu/menu.actions';

@Component({
  selector: 'app-toolbar',
  standalone: false,
  templateUrl: './toolbar.component.html',
  styleUrl: './toolbar.component.css'
})

export class ToolbarComponent{

  

  constructor(
    private authService: AuthService,
    private router: Router,
    private route: ActivatedRoute,
    private sideBarService: SideBarService,
    private menuStore: Store<{menuRdc: any}>
  ) {

    /*this.menuStore.pipe(
      select('menuRdc'),
      map(state => ({ // filtra cuando cambian las propiedades que se usan en este componente
        menuCode: state.menuCode,
      })),
      // evita repeticiones
      distinctUntilChanged((prev, curr) =>
        JSON.stringify(prev) === JSON.stringify(curr)
      )
    ).subscribe(({ menuCode }) => {
      this.menuCode = menuCode;
      this.titleFromMenu = this.menuTitles[menuCode] ?? 'Menú sin título';
    });*/
  }

   titleFromMenu: string = "Titulo Menu";

   ngOnInit(): void {
    this.router.events.subscribe(() => {
      this.updateTitle();
    });
  }

  toggleDrawer() {
    this.sideBarService.toggle();
  }

  showMenuUser(){
    this.sideBarService.showMenuUser();
  }
  private updateTitle() {
    const currentRoute = this.getCurrentRoute();
    let codigoMenu = "";

    if (currentRoute.includes('offers/create')) {
      this.titleFromMenu = 'Crear Oferta';
      codigoMenu = 'offersAdd';
    }else if (currentRoute.includes('offers/edit/')) {
      this.titleFromMenu = 'Detalle Oferta';
      codigoMenu = 'offers';
    }else if (currentRoute.includes('offers')) {
      this.titleFromMenu = 'Ofertas Laborales';
      codigoMenu = 'offers';
    } else if (currentRoute.includes('companies/add')) {
      this.titleFromMenu = 'Crear Empresa';
      codigoMenu = 'companiesAdd';
    } else if (currentRoute.includes('companies/edit')) {
      this.titleFromMenu = 'Modificar Empresa';
      codigoMenu = 'companies';
    }  else if (currentRoute.includes('companies')) {
      this.titleFromMenu = 'Empresas';
      codigoMenu = 'companies';
    } else if (currentRoute.includes('employee/upload')) {
      this.titleFromMenu = 'Carga Empleados';
      codigoMenu = 'uploadEmployee';
    }else if (currentRoute.includes('employee/detail')) {
      this.titleFromMenu = 'Detalle del Empleado';
      codigoMenu = 'employeeDetail';
    }else if (currentRoute.includes('employee')) {
      this.titleFromMenu = 'Lista Empleados';
      codigoMenu = 'listEmployee';
    }else if (currentRoute.includes('budgetCalculation')) {
      this.titleFromMenu = 'Calculo Presupuesto';
      codigoMenu = 'budgetCalculation';
    } else if (currentRoute.includes('users/create')) {
      this.titleFromMenu = 'Crear Usuario';
      codigoMenu = 'usersAdd';
    }else if (currentRoute.includes('users/edit/')) {
      this.titleFromMenu = 'Editar Usuario';
      codigoMenu = 'users';
    }else if (currentRoute.includes('users')) {
      this.titleFromMenu = 'Usuarios';
      codigoMenu = 'users';
    }else if (currentRoute.includes('positions')) {
      this.titleFromMenu = 'Posiciones';
      codigoMenu = 'listPositions';
    }else if (currentRoute.includes('areas/create')) {
      this.titleFromMenu = 'Crear Area';
      codigoMenu = 'addArea';
    }else if (currentRoute.includes('areas/edit/')) {
      this.titleFromMenu = 'Editar Área';
      codigoMenu = 'listAreas';
    }else if (currentRoute.includes('areas')) {
      this.titleFromMenu = 'Áreas';
      codigoMenu = 'listAreas';
    }else if (currentRoute.includes('divisions/create')) {
      this.titleFromMenu = 'Crear Division';
      codigoMenu = 'addDivision';
    }else if (currentRoute.includes('divisions/edit/')) {
      this.titleFromMenu = 'Editar Division';
      codigoMenu = 'listDivisions';
    }else if (currentRoute.includes('divisions')) {
      this.titleFromMenu = 'Divisiones';
      codigoMenu = 'listDivisions';
    }else if (currentRoute.includes('parameters/edit/')) {
      this.titleFromMenu = 'Vista Parámetros';
      codigoMenu = 'listParameters';
    }else if (currentRoute.includes('parameters')) {
      this.titleFromMenu = 'Parámetros';
      codigoMenu = 'listParameters';
    }else if (currentRoute.includes('benefitsGroup/create')) {
      this.titleFromMenu = 'Crear Grupo Beneficio';
      codigoMenu = 'benefetisGroupAdd';
    }else if (currentRoute.includes('benefitsGroup/edit/')) {
      this.titleFromMenu = 'Editar Grupo Beneficio';
      codigoMenu = 'benefetisGroup';
    }else if (currentRoute.includes('benefitsGroup')) {
      this.titleFromMenu = 'Grupos Beneficios';
      codigoMenu = 'benefetisGroup';
    }else if (currentRoute.includes('signatures/create')) {
      this.titleFromMenu = 'Crear Firmas';
      codigoMenu = 'signaturesGroupAdd';
    }else if (currentRoute.includes('signatures/edit/')) {
      this.titleFromMenu = 'Editar Firmas';
      codigoMenu = 'signaturesGroup';
    }else if (currentRoute.includes('signatures')) {
      this.titleFromMenu = 'Grupos Firmas';
      codigoMenu = 'signaturesGroup';
    }else if (currentRoute.includes('holidays/create')) {
      this.titleFromMenu = 'Crear Grupo Vacaciones';
      codigoMenu = 'holidaysGroupAdd';
    }else if (currentRoute.includes('holidays/edit/')) {
      this.titleFromMenu = 'Editar Grupo Vacaciones';
      codigoMenu = 'holidaysGroup';
    }else if (currentRoute.includes('holidays')) {
      this.titleFromMenu = 'Grupos Vacaciones';
      codigoMenu = 'holidaysGroup';
    }else if (currentRoute.includes('requestedSignatures/review')) {
      this.titleFromMenu = 'Revisar Firma';
      codigoMenu = 'listRequestedSignatures';
    }else if (currentRoute.includes('requestedSignatures')) {
      this.titleFromMenu = 'Firmas Solicitadas';
      codigoMenu = 'listRequestedSignatures';
    }else if (currentRoute.includes('benefitsCatalog/create')) {
      this.titleFromMenu = 'Crear Beneficio';
      codigoMenu = 'benefitCatalogAdd';
    }else if (currentRoute.includes('benefitsCatalog/edit/')) {
      this.titleFromMenu = 'Editar Beneficio';
      codigoMenu = 'listBenefitCatalog';
    }else if (currentRoute.includes('benefitsCatalog')) {
      this.titleFromMenu = 'Beneficios Catalogo';
      codigoMenu = 'listBenefitCatalog';
    }else if (currentRoute.includes('adminCompany')) {
      this.titleFromMenu = 'Administrar Empresa';
      codigoMenu = 'adminCompany';
    }else if (currentRoute.includes('withholdingsGroup/create')) {
      this.titleFromMenu = 'Crear Grupo Retenciones';
      codigoMenu = 'withholdingsGroupAdd';
    }else if (currentRoute.includes('withholdingsGroup/edit/')) {
      this.titleFromMenu = 'Editar Grupo Retenciones';
      codigoMenu = 'withholdingsGroup';
    }else if (currentRoute.includes('withholdingsGroup')) {
      this.titleFromMenu = 'Grupos Retenciones';
      codigoMenu = 'withholdingsGroup';
    }else if (currentRoute.includes('costsPerEmployeeGroup/create')) {
      this.titleFromMenu = 'Crear Grupo Costos Empleados';
      codigoMenu = 'costsPerEmployeeGroupAdd';
    }else if (currentRoute.includes('costsPerEmployeeGroup/edit/')) {
      this.titleFromMenu = 'Editar Grupo Costos Empleados';
      codigoMenu = 'costsPerEmployeeGroup';
    }else if (currentRoute.includes('costsPerEmployeeGroup')) {
      this.titleFromMenu = 'Grupos Costos Empleados';
      codigoMenu = 'costsPerEmployeeGroup';
    }else if (currentRoute.includes('costsPerEmployeesCatalog/create')) {
      this.titleFromMenu = 'Crear Costo Empleado';
      codigoMenu = 'costsPerEmployeeCatalogAdd';
    }else if (currentRoute.includes('costsPerEmployeesCatalog/edit/')) {
      this.titleFromMenu = 'Editar Costo Empleado';
      codigoMenu = 'listCostsPerEmployeeCatalog';
    }else if (currentRoute.includes('costsPerEmployeesCatalog')) {
      this.titleFromMenu = 'Costos Empleado Catalogo';
      codigoMenu = 'listCostsPerEmployeeCatalog';
    }else if (currentRoute.includes('withholdingsCatalog/create')) {
      this.titleFromMenu = 'Crear Retencion';
      codigoMenu = 'withholdingCatalogAdd';
    }else if (currentRoute.includes('withholdingsCatalog/edit/')) {
      this.titleFromMenu = 'Editar Retencion';
      codigoMenu = 'listWithholdingCatalog';
    }else if (currentRoute.includes('withholdingsCatalog')) {
      this.titleFromMenu = 'Retenciones Catalogo';
      codigoMenu = 'listWithholdingCatalog';
    }else if (currentRoute.includes('formulasGroup/create')) {
      this.titleFromMenu = 'Crear Grupo Formulas';
      codigoMenu = 'formulaGroupAdd';
    }else if (currentRoute.includes('formulasGroup/edit/')) {
      this.titleFromMenu = 'Editar Grupo Costos Formulas';
      codigoMenu = 'formulaGroup';
    }else if (currentRoute.includes('formulasGroup')) {
      this.titleFromMenu = 'Grupos Costos Formulas';
      codigoMenu = 'formulaGroup';
    }
    else if (currentRoute.includes('variablesCatalog/create')) {
      this.titleFromMenu = 'Crear Variable';
      codigoMenu = 'variableCatalogAdd';
    }else if (currentRoute.includes('variablesCatalog/edit/')) {
      this.titleFromMenu = 'Editar Variable';
      codigoMenu = 'listVariableCatalog';
    }else if (currentRoute.includes('variablesCatalog')) {
      this.titleFromMenu = 'Variables Catalogo';
      codigoMenu = 'listVariableCatalog';
    }
    else if (currentRoute.includes('objectsCatalog/create')) {
      this.titleFromMenu = 'Crear Objecto';
      codigoMenu = 'objectCatalogAdd';
    }else if (currentRoute.includes('objectsCatalog/edit/')) {
      this.titleFromMenu = 'Editar Objecto';
      codigoMenu = 'listObjectCatalog';
    }else if (currentRoute.includes('objectsCatalog')) {
      this.titleFromMenu = 'Objectos Catalogo';
      codigoMenu = 'listObjectCatalog';
    }
    this.menuStore.dispatch(setMenuAct({ menuCode: codigoMenu }));
  }

  // Método para obtener la ruta activa
  private getCurrentRoute(): string {
    let route = '';
    let currentRoute = this.route.root;

    while (currentRoute.firstChild) {
      currentRoute = currentRoute.firstChild;
    }

    route = currentRoute.snapshot.url.map(segment => segment.path).join('/');
    return route;
  }
}